<template>
    <div class="dropdown-menu relative flex flex-col gap-0.5 rounded-lg border border-gray-200 dark:border-default bg-white dark:bg-surface-card p-1 shadow-xl">
        <template v-if="items.length">
            <button
                v-for="(item, index) in items"
                :key="index"
                class="flex items-center rounded-lg p-2 hover:bg-gray-300 dark:hover:bg-subtle dark:text-txt-body"
                :class="{ 'bg-gray-200 dark:bg-subtle hover:bg-gray-300 dark:hover:bg-subtle': index === selectedIndex }"
                @click="selectItem(item)"
            >
                <CText>{{ item.label }}</CText>
            </button>
        </template>

        <div v-else class="item"><CText>Žiadne výsledky</CText></div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import CText from '../CText.vue'

interface Item {
    id: string
    label: string
}

interface Props {
    items: Item[]
    command: (item: Item) => void
}

const props = defineProps<Props>()
const selectedIndex = ref(0)

watch(() => props.items, () => {
    selectedIndex.value = 0
})

function onKeyDown({ event }: { event: KeyboardEvent }) {
    if (event.key === 'ArrowUp') {
        upHandler()
        return true
    }

    if (event.key === 'ArrowDown') {
        downHandler()
        return true
    }

    if (event.key === 'Enter') {
        enterHandler()
        return true
    }

    return false
}

function upHandler() {
    selectedIndex.value = (selectedIndex.value + props.items.length - 1) % props.items.length
}

function downHandler() {
    selectedIndex.value = (selectedIndex.value + 1) % props.items.length
}

function enterHandler() {
    const item = props.items[selectedIndex.value]
    if (item) selectItem(item)
}

function selectItem(item: Item) {
    props.command(item)
}

defineExpose({
    onKeyDown
})
</script>